import { Link } from 'react-router-dom';

const materials = [
  {
    image: 'https://readdy.ai/api/search-image?query=Modern%20professional%20business%20meeting%20scene%20with%20diverse%20team%20discussing%20strategy%20around%20a%20bright%20white%20conference%20table%2C%20warm%20natural%20daylight%20from%20large%20windows%2C%20clean%20minimalist%20office%20interior%20with%20subtle%20teal%20accent%20walls%2C%20corporate%20training%20atmosphere%2C%20soft%20shadows%2C%20editorial%20photography%20style%2C%20no%20text%20no%20logos%20no%20branding&width=800&height=500&seq=encyclo-readnext-01&orientation=landscape',
    title: 'Что такое корпоративное обучение',
    description: 'Полное руководство по корпоративному обучению: виды, преимущества, современные методы и этапы внедрения.',
    to: '/enciklopediya-korporativnogo-obucheniya/chto-takoe-korporativnoe-obuchenie',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Diverse%20team%20of%20sales%20professionals%20in%20a%20bright%20modern%20training%20room%20engaged%20in%20active%20role-play%20exercises%2C%20large%20whiteboard%20with%20sales%20funnel%20diagram%2C%20warm%20natural%20lighting%20through%20tall%20windows%2C%20professional%20corporate%20setting%20with%20teal%20accent%20details%2C%20clean%20minimalist%20aesthetic%2C%20editorial%20photography%2C%20no%20text%20no%20logos&width=800&height=500&seq=encyclo-readnext-02&orientation=landscape',
    title: 'Обучение отдела продаж',
    description: 'Как повысить конверсию, улучшить работу с возражениями и увеличить продажи через системное обучение.',
    to: '/enciklopediya-korporativnogo-obucheniya/obuchenie-otdela-prodazh',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Confident%20business%20leader%20presenting%20strategy%20to%20attentive%20team%20in%20a%20bright%20modern%20boardroom%20with%20floor-to-ceiling%20windows%2C%20professional%20corporate%20atmosphere%2C%20warm%20neutral%20tones%20with%20teal%20accent%20elements%2C%20soft%20natural%20daylight%2C%20clean%20contemporary%20design%2C%20leadership%20development%20theme%2C%20editorial%20photography%2C%20no%20text%20no%20logos&width=800&height=500&seq=encyclo-readnext-03&orientation=landscape',
    title: 'Тренинг для руководителей',
    description: 'Развитие управленческих компетенций, лидерских качеств и навыков эффективного управления командой.',
    to: '/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Corporate%20team%20building%20outdoor%20activity%20with%20diverse%20group%20of%20professionals%20engaged%20in%20collaborative%20problem-solving%20exercises%2C%20green%20park%20setting%20with%20modern%20architecture%20in%20background%2C%20bright%20natural%20daylight%2C%20energetic%20positive%20atmosphere%2C%20professional%20yet%20casual%20attire%2C%20warm%20tones%2C%20editorial%20photography%20style%2C%20no%20text%20no%20logos%20no%20branding&width=800&height=500&seq=encyclo-readnext-04&orientation=landscape',
    title: 'Командообразование',
    description: 'Формирование сплоченных команд через тимбилдинги и бизнес-игры для улучшения корпоративной культуры.',
    to: '/enciklopediya-korporativnogo-obucheniya/komandoobrazovanie',
  },
];

export default function ReadNextSection() {
  return (
    <section id="read-next" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-6 leading-tight">
            Читайте также
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Продолжите изучение материалов энциклопедии — мы собрали самые полезные статьи по корпоративному обучению.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {materials.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="group bg-white rounded-2xl overflow-hidden border border-gray-100 hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-xs leading-relaxed mb-3 line-clamp-2">{item.description}</p>
                <span className="inline-flex items-center gap-1 text-teal-600 font-semibold text-sm group-hover:gap-2 transition-all">
                  Читать
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}